import FreestyleController from 'ember-freestyle/controllers/freestyle';

export default FreestyleController;
